---
nb:
  navigation:
    error:
      no_company_selected: Ingen selskap valgt
      too_many_power_plants_selected: For mange kraftverk valgt
    language:
      de: Tysk
      en: Engelsk
      fr: Fransk
      nb: Norsk
      select: Velg språk
    main_menu:
      admin_market_prices: Markedspriser
      admin_volumes: Volumer
      admin_weather: Værprognoser
      api_access: API-tilgang
      api_docs: API-dokumentasjon
      availability: Nedetidsanalyse
      availability_analysis: Nedetidsanalyse
      benchmarking: Benchmarking
      budget_forecasts: Budsjettprognoser
      commercial_scada: Kommersiell SCADA
      community_access: Community access
      companies: Selskaper
      components: Komponenter
      contracts: Kontrakter
      data_export: Dataeksport
      elcert_and_goos: Elsertifikater og GoOs
      elhub: Elhub
      fall_lease: Falleie
      feature_requests: Forespørsler
      follow_up: PPA Oppfølging
      full_map: Fullt kart
      home: Hjem
      liquidity_planning: Likviditetsplanlegging
      log_out: Logg ut
      map: Kart
      market_data: Prisdata
      market_outlook: Markedsutsikter
      market_prices: Markedspriser
      marketplace: Markedsplass
      more_information: Mer informasjon
      nest: Nest
      news_items: Innlegg
      nve_plants: NVE-anlegg
      o_and_m_dashboard_v1: O&M-dashboard v1
      om_dashboard: Dashboard
      operations: Drift
      portfolio: Portefølje
      portfolio_stats: Porteføljestatistikk
      power_plants: Kraftverk
      pp_info: Kraftverksinfo
      ppa_pricing: PPA Pricing
      production_scheduling: Prod. planlegging
      production_simulation_plan: Produksjonssimuleringsplan
      profile: Profil
      public_kiosk_mode: Offentlig kioskmodus
      responsibles: Ansvarlige
      root: Rotnivå
      subsidiaries: Datterselskaper
      suppliers: Leverandører
      task_management: Oppgavestyring
      users: Brukere
      white_labeling: White labeling
    production_simulation_plan_query: Kjør produksjonssimuleringsforespørsel
